import { render, staticRenderFns } from "./AppBarNotification.vue?vue&type=template&id=34b488d6"
import script from "./AppBarNotification.vue?vue&type=script&lang=js"
export * from "./AppBarNotification.vue?vue&type=script&lang=js"
import style0 from "./AppBarNotification.vue?vue&type=style&index=0&id=34b488d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports